import { Node } from 'slate';
import { DEFAULTS_OPTIONS } from '@doltech/ui/lib/figma/BlogEditor/editorDefaultOptions';

export const convertData = (children) => {
  const data = [];
  children?.forEach((item) => {
    if (item.type === DEFAULTS_OPTIONS.h2.type) {
      data.push(item);
    }
    if (item.type === DEFAULTS_OPTIONS.h3.type && data[data.length - 1]) {
      if (!data[data.length - 1].sub) {
        data[data.length - 1].sub = [];
      }
      data[data.length - 1].sub.push(item);
    }
  });
  return data;
};

export const stringlifyData = (data) => {
  return JSON.parse(data)
    ?.map((item) => Node.string(item))
    .join('');
};
